/**
 * @fileoverview Household theme - match household object emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Household theme with everyday items from home.
 */
export class HouseholdTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'household',
            'Household',
            allLabels.household,
            { numPairs: 4, isPremium: false, hasMovement: false, ...options }
        );
    }
}
